import {
  LightboxProps as OriginalLightboxProps,
  PluginProps,
  Slide,
} from 'yet-another-react-lightbox';
import PDFViewer from './PdfViewer';

declare module 'yet-another-react-lightbox' {
  interface SlideTypes {
    pdf: SlidePdf;
  }
}

interface SlidePdf {
  type: 'pdf';
  src: string;
}

export const defaultPdfProps = {
  controls: true,
};

interface LightboxProps extends OriginalLightboxProps {
  pdf?: typeof defaultPdfProps;
}

function isPdfSlide(slide: Slide): slide is SlidePdf {
  return slide.type === 'pdf';
}
export const resolvePdfProps = (pdf: LightboxProps['pdf']) => ({
  ...defaultPdfProps,
  ...pdf,
});

export function Pdf({ augment }: PluginProps) {
  augment(
    ({ render: { slide: renderSlide, ...restRender }, ...restProps }) => ({
      render: {
        slide: ({ slide, offset, rect }) => {
          if (isPdfSlide(slide)) {
            return (
              <PDFViewer key={slide.src} url={slide.src} title={slide.type} />
            );
          }
          return renderSlide ? renderSlide({ slide, offset, rect }) : null;
        },
        ...restRender,
      },
      ...restProps,
    }),
  );
}
